"use client";

import { useCallback, useContext, useEffect, useMemo } from "react";
import {
    FeedRidContext,
    PrematchUpcomingFeedContext,
    useWebsocketUpdates,
    WebsocketContext,
} from "@finbackoffice/site-core";
import { HoursRange, IClientError } from "@finbackoffice/websocket-client";
import { useSocketStorage } from "hooks";

export const usePrematchUpcomingSports = (hoursRange?: number): void => {
    const { setPrematchUpcoming } = useContext(PrematchUpcomingFeedContext);
    const { connected } = useContext(WebsocketContext);
    const { prematchUpcomingRid } = useContext(FeedRidContext);
    const { getSports } = useSocketStorage(prematchUpcomingRid);
    // const feed = useGetCurrentFeedType();

    const handleSetPrematch = useCallback(
        (response: { rid: string }, error: IClientError) => {
            if (!error) {
                const rid = response.rid;
                const sports = getSports(rid);
                setPrematchUpcoming({
                    rid,
                    sports,
                    loading: false,
                    error: "",
                });
            } else {
                console.error(error);

                setPrematchUpcoming((state) => ({
                    ...state,
                    loading: false,
                    error: error.error,
                }));
            }
        },
        [getSports, setPrematchUpcoming],
    );

    const payload = useMemo(() => ({ hours: hoursRange || HoursRange.ALL }), [hoursRange]);

    useWebsocketUpdates("prematch", handleSetPrematch, undefined, payload);

    /* useEffect(() => {
        subscribe();

        return () => {
            unsubscribe();
            setPrematchUpcoming({ rid: "", sports: [], loading: true, error: "" });
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connected, hoursRange]); */

    useEffect(() => {
        return () => {
            if (connected) {
                setPrematchUpcoming({ rid: "", sports: [], loading: true, error: "" });
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hoursRange, connected]);

    useEffect(() => {
        return () => {
            setPrematchUpcoming({
                rid: "",
                sports: [],
                loading: true,
                error: "",
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
